import React, {useEffect}from 'react';
import { ToastContainer } from 'react-toastify';
import { useAppDispatch, useAppSelector } from './ReduxToolkit/hook';
import { fetchPanelConfig } from './ReduxToolkit/Reducers/PanelConfigReducer';
import Loader from './Layout/Loader';
import Routers from './Routes';

function App() {

  const dispatch = useAppDispatch();
  const panelConfig = useAppSelector(state => state.panelConfig.data);
  const panelLoading = useAppSelector(state => state.panelConfig.loading);

  // useEffect(() => {
  //   dispatch(fetchPanelConfig());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (!panelConfig) return;
  //   const root = document.documentElement;
  //   root.style.setProperty('--theme-default', panelConfig.theme.primary);
  //   root.style.setProperty('--theme-secondary', panelConfig.theme.secondary);

  //   if (panelConfig.title) {
  //     document.title = panelConfig.title;
  //   }

  //   if (panelConfig.images.favicon) {
  //     const link =
  //       document.querySelector<HTMLLinkElement>("link[rel~='icon']") ||
  //       document.createElement('link');
  //     link.rel = 'icon';
  //     link.href = panelConfig.images.favicon;
  //     document.head.appendChild(link);
  //   }
  // }, [panelConfig]);


  //   useEffect(() => {
  //   dispatch(fetchPanelConfig());
  //   }, [dispatch]);

  // useEffect(() => {
  //   if (!panelConfig) return;

  //   // Set CSS vars
  //   const root = document.documentElement;
  //   root.style.setProperty('--theme-default', panelConfig.theme.primary);
  //   root.style.setProperty('--theme-secondary', panelConfig.theme.secondary);

  //   // Title
  //   document.title = panelConfig.title;

  //   // Favicon
  //   if (panelConfig.images.favicon) {
  //     const link =
  //       document.querySelector<HTMLLinkElement>("link[rel~='icon']") ||
  //       document.createElement('link');
  //     link.rel = 'icon';
  //     link.href = panelConfig.images.favicon;
  //     document.head.appendChild(link);
  //   }

  // }, [panelConfig]);



  return (
    <>
      <Routers/>
      <ToastContainer />
    </>
  );
}

export default App;
